enum CardIssuerCode {
  Not_In_Use = 0,
  Visa_Debit = 1,
  UK_Electron = 2,
  Visa_Purchasing = 3,
  Visa = 4,
  MasterCard = 5,
  UK_Maestro = 6,
  SOLO_DISCONTINUE = 7,
  JCB = 8,
  Maestro = 9,
  VISA_ATM = 10,
  ARVAL_PHH = 11,
  Amex = 12,
  DinersClubInternational = 13,
  Laser = 14,
  DUET = 15,
  HN_Mastercard = 16,
  HN_PLCC = 17,
  Tesco_Clubcard = 18,
  DANKORT = 19,
  Discover = 20,
  US_Debit = 21,
  Debit_MasterCard = 22,
  MasterCard_Purchasing = 23,
  Bank_Of_America = 24,
  Newday_MasterCard = 25,
  Newday_Staff_Card = 26,
  Newday_Store_PLC = 27,
  Newday_Temporary = 28,
  Alipay_BarCode = 29,
  YESpay_Virtual_Card = 80,
  Flexcash_Love_2_Reward = 81,
  YESpay_Gift_Card = 90,
  PPS_Gift_Card = 91
}

export default CardIssuerCode;
